export default "__VITE_ASSET__bfWI4gdZ__"